"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceWebcam = void 0;
var SourceWebcam;
(function (SourceWebcam) {
    SourceWebcam["user"] = "user";
    SourceWebcam["environment"] = "environment";
})(SourceWebcam = exports.SourceWebcam || (exports.SourceWebcam = {}));
//# sourceMappingURL=RPPGCamera.types.js.map